/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.boostSDAppConfig.searchSettings.suggestionMobileStyle = "style2";

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('Cart', {
      name: 'FilterOption Remove Prefix',
      apply: () => ({
        afterRender: (element) => {
          // can custom for any Filter Option check props to customize for special FilterOption
          console.log('render: ', element.getRootElm());
          try {
            const rootElm = element.getRootElm();
            if (rootElm !== null) {
              if (rootElm.querySelector('.pdp_offer') == null) {
                // const customHtml = '<div class="boost-sd__custom-html">GET 5% OFF ON YOUR FIRST PURCHASE | USE CODE - <span class="boost-sd__bold">BHAMA5</strong></div>';
                const customHtml = '<div class="pdp_offer">' +
                                      '<span>Available Offers:</span>' +
                                      '<p>- Add. 5% off on prepaid orders</p>' +
                                      '<p>- Get 15% off on orders above 1999, use code - FESTIVE15</p>'
                                    '</div>';
                rootElm.querySelector('.boost-sd__cart-footer').insertAdjacentHTML('afterbegin', customHtml);
              }
            }
          } catch(error) {
            console.log(error);
          }
        },
      }),
    })
}]);

const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                     /* use pure js here */
                    if (productData.tags.includes('New arrival')) {
                      const newHtml = `<div class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__product-label--new" style="color: rgb(255, 255, 255); background-color: rgb(230, 181, 217);"><span class="boost-sd__product-label-text"><span>New</span></span></div>`
                      if (!productItem.querySelector('.boost-sd__product-label--new')) {
                        productItem.querySelector('.boost-sd__product-image-column--left').innerHTML = '';
                         productItem.querySelector('.boost-sd__product-image-column--left').insertAdjacentHTML('beforeend', newHtml);
                      }
                    }

                    if (productData.tags.includes('Best Seller')) {
                      const bestSellerHtml = `<div class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__product-label--best-seller" style="color: rgb(255, 255, 255); background-color: rgb(230, 181, 217);"><span class="boost-sd__product-label-text"><span>Best Seller</span></span></div>`
                      if (!productItem.querySelector('.boost-sd__product-label--best-seller')) {
                        productItem.querySelector('.boost-sd__product-image-column--left').innerHTML = '';
                         productItem.querySelector('.boost-sd__product-image-column--left').insertAdjacentHTML('beforeend', bestSellerHtml);
                      }
                    }
                    
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);

